import * as t from './actionTypes';
import { fetchDnsSetupRequest, fetchDnsSetupResponse, fetchDnsSetupError } from './actions';
import type { DnsEntryReducerState } from './types';

type DnsSetupReducerActionType =
  | ReturnType<typeof fetchDnsSetupRequest>
  | ReturnType<typeof fetchDnsSetupResponse>
  | ReturnType<typeof fetchDnsSetupError>;

export const initialState: DnsEntryReducerState = {
  entries: [],
  targetDomain: '',
  isLoading: false,
};

export const dnsSetupReducer = (state = initialState, action: DnsSetupReducerActionType) => {
  switch (action.type) {
    case t.FETCH_DNS_SETUP_RESPONSE: {
      return {
        ...state,
        ...(action as ReturnType<typeof fetchDnsSetupResponse>).response,
        isLoading: false,
      };
    }
    case t.FETCH_DNS_SETUP_REQUEST: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case t.FETCH_DNS_SETUP_ERROR: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default: {
      return state;
    }
  }
};
